import { render } from "./GuideSliderProfile.vue?vue&type=template&id=0f50e449"
import script from "./GuideSliderProfile.vue?vue&type=script&lang=js"
export * from "./GuideSliderProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__